import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { BaseEntityLink } from "shared/components/common/base-entity-link";
import { fontRoboto, theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

export const StyledBaseEntityLink = styled(BaseEntityLink)``;

export const MenuItem = styled.span`
  color: #000000;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 120%;

  transition: color 0.2s ease-in-out;

  &:hover {
    color: #2957b5;
  }
`;

export const Container = styled.nav`
  min-inline-size: 0;
`;

export const StyledSwiper = styled(Swiper)`
  position: relative;

  margin: 0;
  padding: 0;

  overflow-y: hidden;

  .swiper-wrapper {
    block-size: 24px;
  }

  &:not(.swiper-initialized) {
    .swiper-button-prev,
    .swiper-button-next {
      background: unset;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    display: flex;
    align-items: center;

    inline-size: auto;

    &:not(:last-child) {
      margin-inline-end: 16px;

      ${theme.breakpoints.up("desktop")} {
        margin-inline-end: 14px;
      }
    }
  }
`;
